export default {
  categoriesPublished(state) {
    return state.categories.data.filter((item) => item.isPublish === '1');
  },
  hotSearchPublished(state) {
    return state.hotSearch.data.filter((item) => item.isHot === '1');
  },
  tagGoodsGetter: (state) => (name, length) => state.tagGoods[name].data.slice(0, length),
  countryNameGetter: (state) => (id) => `${state.webConfig.countryList.find((item) => item.id === id).dnames}(${
    state.webConfig.countryList.find((item) => item.id === id).dnamesEn
  })`,
  countryGetter(state) {
    return state.usedCountry;
  },
  languageGetter(state) {
    return state.language.value;
  },
  rebateGetter(state) {
    return state.user ? +state.user.rebate : 100;
  },
};
